import React, { useState } from "react";
import { ColumnProps } from "antd/lib/table/interface";
import Layout from "../components/Layout";
import StuTable from "../components/StuTable";
import useRequest from "../../../../utils/useRequest";
import {
    getExamStudentMultiScreenList,
    StudentMultiScreenListItem
} from "../../../../service/exam";
import AsideMultiple from "./components/AsideMultiple";
import InvigilationProvider from "../context";

export default function MultipleScreen() {
    const [examId, setExamId] = useState("");
    const [studentName, setStudentName] = useState("");

    const [data, { loading }, refresh] = useRequest(
        () => getExamStudentMultiScreenList({ studentName, examId }),
        {},
        [examId, studentName]
    );

    const columns: ColumnProps<StudentMultiScreenListItem>[] = [
        {
            title: "多屏记录",
            dataIndex: "multiScreenCount",
            align: "center"
        }
    ];

    return (
        <InvigilationProvider
            examList={data?.conditionQueryList || []}
            dataSource={data?.dataList || []}
            examId={examId}
            setExamId={setExamId}>
            <Layout
                title="考生多屏记录"
                refresh={refresh}
                table={
                    <StuTable
                        onErrChange={refresh}
                        extraColumns={columns}
                        buttonShow={[true, false, true, true]}
                        dataSource={data?.dataList || []}
                        loading={loading}
                    />
                }
                aside={<AsideMultiple />}
                onSearch={setStudentName}
            />
        </InvigilationProvider>
    );
}
